import styled from 'styled-components';

export const Body = styled.div`
  border-radius: 8px;
  box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.07);
  background-color: #ffffff;
  padding: 30px;
`;

export const LabelMain = styled.label`
  font-family: Arial;
  font-size: 38px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #005394;
`;

export const LabelSecondary = styled(LabelMain)`
  font-size: 14px;
  color: #4a4a4a;
`;

export const LabelValues = styled(LabelMain)`
  font-size: 14px;
  margin-left: 5px;
  margin-right: 5px;

  color: #858585;
`;

export const BoxValues = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${props => (props.start ? 'start' : '')};
`;

export const RowValues = styled(BoxValues)`
  display: flex;
  justify-content: center;
  margin-left: 20px
`;

export const TrilhaRow = styled.div`
  background-color: rgba(23, 179, 210, 0.1);
  margin-top: 20px;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 76px;
  width: 100%;
  padding: 42px;
`;

export const Row = styled.div`
  background-color: ${props => (props.color ? 'rgba(23, 179, 210, 0.1)' : '')};
  height: ${props => (props.color ? 'height: 76px !important' : '')};
  margin-right: 0 !important;
  margin-left: 0;
  align-items: center;
`;
